/**
 * Model to handle roles
 */
define('dataSource/logoDataUri',['jquery', 'atn/atn', 'lodash','dataSource/uiVersion','knockout'],
    function($, atn, _, uiVersion, ko) {
        'use strict';

        var rebrandingResourceFolder = atn.config.oemRebrandingFolder;
        var rebrandingResourceObj = atn.config.oemResourcesMap;
        var companyLogoDataUri = ko.observable('');

        return {
            getCompanyLogoDataUri: getCompanyLogoDataUri,
            companyLogoDataUri: companyLogoDataUri
        };

        /**
         * fetches the roles into roles
         * @return {promise} promise object for fetching roles
         */
        function getCompanyLogoDataUri() {
            var promise = $.get( rebrandingResourceFolder + 
                rebrandingResourceObj.PDF_LOGO + '?id=' + uiVersion.uiVersion.id),
                deferred = $.Deferred();
            promise.done(function(response) {
                companyLogoDataUri(response);
                _.defer(deferred.resolve, response);
            }).fail(function(xhr) {
                _.defer(deferred.reject, xhr);
            });
            return deferred.promise();
        }
    });
